export const state = () => ({})

export const actions = {
	async trackPage({ rootState, rootGetters, dispatch }, { pageName, data }) {
		const mixpanel = useNuxtApp().$mixpanel

		if (rootState.auth !== null) {
			await dispatch('company/retrieve', { companyId: rootGetters.companyId }, { root: true })
			await dispatch('stores/list', { companyId: rootGetters.companyId }, { root: true })
			mixpanel.identify(rootState.company.company.id)
			mixpanel.people.set({
				$email: rootState.company.company.email,
				plan_id: rootState.company.company.plan_id,
				has_shopify: !!rootState.stores.store.id,
			})
			mixpanel.people.append('pages_visited', pageName)
			mixpanel.people.increment('page_views', 1)
		}
		mixpanel.track(pageName, data)
	},

	trackAction(_, { actionName, data }) {
		useNuxtApp().$mixpanel.track(actionName, data)
	},
}
